import React from 'react';

import {
  minValue,
  required,
} from 'react-admin';

import {
  Grid,
  Typography,
} from '@mui/material';

import Label from '../../../customFields/Label';
import labels from '../../../constants/labels';
import { timePeriodChoices } from '../../../constants/timePeriods';

import NumberInput from '../../layout/inputFields/NumberInput';
import SelectInput from '../../layout/inputFields/SelectInput';
import InfoPopover from '../../layout/InfoPopover';

import { DefaultThresholdInput } from './ThresholdInput';

const CategorizationAmountThreshold = () => (
  <Grid size={12}>
    <Grid container spacing={1}>
      <Grid size={12}>
        <DefaultThresholdInput />
      </Grid>
      <Grid size={12}>
        <Label
          variant="label"
          title="Period parameters"
          info="The period that the amount threshold will be checked against."
        />
      </Grid>
      <Grid size={6}>
        <NumberInput
          source="ruleParameters.period.amount"
          fullWidth
          label="Length"
          validate={[required(), minValue(1)]}
        />
      </Grid>
      <Grid size={6}>
        <SelectInput
          source="ruleParameters.period.unit"
          choices={timePeriodChoices}
          fullWidth
          label="Period"
          validate={[required(), minValue(1)]}
        />
      </Grid>
      <Grid size={12}>
        <Typography variant="label">Category</Typography>
        <SelectInput
          source="ruleParameters.category"
          choices={labels}
          fullWidth
          label="Category"
          validate={required()}
          popups={(
            <InfoPopover title="Category" content="The transactions with the selected category that is to be checked against the amount threshold." />
          )}
        />
      </Grid>
    </Grid>

  </Grid>

);

export default CategorizationAmountThreshold;
